
export function getPinStyles(template, styleName) {
  if(template !== 'map-exhibit') {
    return { pinImage: 'maps_pin_red.png', pinImageSelected: 'maps_pin_red.png' }
  }

  const list  = {
    'dark-blue':    { pinImage: 'map-pin-dark-blue.png', pinImageSelected: 'map-pin-dark-blue-active.png' },
    'light-blue':   { pinImage: 'maps_pin_grey.png', pinImageSelected: 'maps_pin_grey_red_selected.png' },
    'copper-gray':  { pinImage: 'map-pin-copper-gray.png', pinImageSelected: 'map-pin-copper-gray-active.png' },
    'red-gray':     { pinImage: 'maps_pin_grey.png', pinImageSelected: 'maps_pin_grey_red_selected.png' },
    'default':      { pinImage: 'maps_pin_grey.png', pinImageSelected: 'maps_pin_grey_red_selected.png' },
    'black-yellow': { pinImage: 'maps_pin_grey.png', pinImageSelected: 'maps_pin_grey_red_selected.png' },
    'weird-art':    { pinImage: 'map-pin-weird-art.png', pinImageSelected: 'map-pin-weird-art-active.png' },
  }

  let pinStyle = list[styleName]
  if(!pinStyle) {
    pinStyle = { pinImage: 'maps_pin_grey.png', pinImageSelected: 'maps_pin_grey_red_selected.png' }
  }

  return pinStyle
}
